module.exports = __webpack_public_path__ + "img/tn.052969d1.svg";